export enum CompanyType {
  COMPANY = 'company',
  PERSON = 'person',
}

export function castCompanyTypeEnum(value: CompanyType): string {
  switch (value) {
    case CompanyType.COMPANY:
      return 'CUSTOMERS.COMPANY_TYPE_COMPANY';
    case CompanyType.PERSON:
      return 'CUSTOMERS.COMPANY_TYPE_PERSON';
  }
}
